<div
  class="app-section-loader-shell @container"
  [attr.aria-busy]="(activeSectionLoader$ | async) ? 'true' : null"
>
  <ng-content></ng-content>

  <myt-app-section-loader-overlay
    [sectionLoader]="visibleSectionLoader$ | async"
  ></myt-app-section-loader-overlay>
</div>
